// export const environment = {
//   production: true,
//   orgAppId: 6120,
//   baseAPIUrl: 'https://kenindia-travel-api.insure.digital/',
//   authAPIURL: 'https://auth-api.insure.digital/',
//   jengapgwUrl:'https://v3-uat.jengapgw.io/processPayment',
//   siteBaseUrl:'https://kenindiab2c-travel.insure.digital/',
//   ipifyUrl:'https://api.ipify.org?format=json'
// };
export const environment = {
  production: true,
  orgAppId: 6120,
  baseAPIUrl: 'https://kenindia-api.insure.digital/',
  authAPIURL: 'https://auth-api.insure.digital/',
  jengapgwUrl:'https://v3-uat.jengapgw.io/processPayment',
  siteBaseUrl:'https://online-kenindia.insure.digital/',
  ipifyUrl:'https://api.ipify.org?format=json'
};